
export const HistoryDespCard = ({ item }) => {

    let deSerilize = JSON.parse(item.metadata);
    const performedBy = item.performedBy ?? item.agentName ?? "N/A";

    return (
        <>
            <div>
                {
                    item.actionId == 4 ?
                        <p className="mb-0">
                            {
                                item.parentLogId ?
                                    <>
                                        <span className="fw-bold">Property Status Updation: </span>
                                        <span className="px-1">{deSerilize.oldEstateStatus ? deSerilize.oldEstateStatus : ""}</span>
                                        <span>to</span>
                                        <span className="px-1">{deSerilize.newEstateStatus ? deSerilize.newEstateStatus : ""}</span>
                                    </>
                                    :
                                    <>
                                        <span className="fw-bold">Desciption : </span>
                                        <span>Delete</span>
                                        <span className="fw-bold px-1">{deSerilize.freeslotDeleteCount != undefined ? deSerilize.freeslotDeleteCount : ""}</span>
                                        <span>free slots using the Smart Calendar Agent Site.</span>
                                    </>
                            }
                        </p>
                        : item.actionId == 1 ?
                            <>
                                <span className="fw-bold">Property Status Updation: </span>
                                <span className="px-1">{deSerilize.oldEstateStatus ? deSerilize.oldEstateStatus : ""}</span>
                                <span>to</span>
                                <span className="px-1">{deSerilize.newEstateStatus ? deSerilize.newEstateStatus : ""}</span>
                            </>
                            :
                            <p className="mb-0">
                                <span className="fw-bold"> Desciption :</span>
                                <span>free slots using the Smart Calendar Agent Site.</span>
                            </p>
                }
                <p className="mb-0"> <span className="fw-bold">Performed By:</span> {performedBy}</p>
            </div>
        </>
    )

}